import { eHocLaiThiLaiActionsObj } from "../../action-types/hoc-lai-thi-lai/IHocLaiThiLaiActions";
import { generateActions } from "../generateActions";

export const hocLaiThiLaiActions = {
    ...generateActions(eHocLaiThiLaiActionsObj, "HOC_LAI_THI_LAI")
}